import React from "react";
import ReactGA from "react-ga";

export type EnrolmentSuccessProps = {
  gtag: any;
  gaTrackingId: string;
  gaTracking: string;
  isDismissClick: () => void;
  patientName: string;
  patientDob: string;
  recallPeriod: string;
};

const EnrolmentSuccess = ({
  gtag,
  gaTrackingId,
  gaTracking,
  patientDob,
  patientName,
  recallPeriod,
  isDismissClick,
}: EnrolmentSuccessProps) => {
  ReactGA.initialize(gaTrackingId);
  ReactGA.pageview(`/enrolments/success?${gaTracking}`);

  gtag("event", "conversion", {
    allow_custom_scripts: true,
    send_to: "DC-9279728/provi0/provi0+standard",
  });

  return (
    <div className="mdc-layout-grid__inner">
      <div className="mdc-layout-grid__cell mdc-layout-grid__cell--span-3" />

      <div className="mdc-layout-grid__cell mdc-layout-grid__cell--span-6">
        <div className="popup-success">
          <i className="material-icons check_circle">check_circle</i>
          <i className="material-icons clear" onClick={isDismissClick}>
            clear
          </i>
          <div className="popup-success-content">
            <b>Successfully sent</b>

            <p>
              Your patient's details have been successfully sent to KeepSight.
            </p>

            <div className="mdc-layout-grid__inner">
              <div className="mdc-layout-grid__cell mdc-layout-grid__cell--span-3" />
              <div className="mdc-layout-grid__cell mdc-layout-grid__cell--span-6">
                <table className="popup-table">
                  <tbody>
                    <tr>
                      <td>Name</td>
                      <td>
                        <b>{patientName}</b>
                      </td>
                    </tr>
                    <tr>
                      <td>Date of birth</td>
                      <td>
                        <b>{patientDob}</b>
                      </td>
                    </tr>
                    <tr>
                      <td>Recall period</td>
                      <td>
                        <b>{recallPeriod}</b>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EnrolmentSuccess;
